import { getStorageList } from '@/api/settings/storage'
import CONST from '@/utils/const'

const state = {
  storageList: [], // 普通库房列表
  storageFullList: [] // 全部库房列表
}

const mutations = {
  init: (state, { storageList, storageFullList }) => {
    state.storageList = storageList
    state.storageFullList = storageFullList
  }
}

const actions = {
  // 初始化库房信息
  init({ dispatch, commit }) {
    return new Promise((resolve, reject) => {
      getStorageList({
        page: CONST.PAGINATION.PAGE,
        rows: CONST.PAGINATION.MAX_ROWS,
        sort: 'id',
        order: 'desc'
      }).then(resp => {
        const storageFullList = resp.rows || []
        const storageId = CONST.STORAGE_TYPE.find(type => type.name === '普通库房').id
        commit('init', {
          storageList: storageFullList.filter(storage => storage.type === storageId),
          storageFullList: storageFullList
        })
        dispatch('tip/add', { key: Math.random(), name: '初始化库房信息成功.' }, { root: true })
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/storage.js